import { render, staticRenderFns } from "./PetrolCategory.vue?vue&type=template&id=7e7ed586&"
import script from "./PetrolCategory.vue?vue&type=script&lang=js&"
export * from "./PetrolCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports